import * as CL from '@design-system/component-library';
import * as React from 'react';
import { FilterType } from '../ProductGrid/ProductGridFilter';
import { dsClass } from '../../common/constants/dsClasses';

import './FilterTag.scss';

interface FilterTagProps {
  subcategory: string;
  label: string;
  onRemoveFilter: () => void;
}

export const FilterTag: React.FC<FilterTagProps> = ({ subcategory, label, onRemoveFilter }) => {
  return (
    <div key={subcategory + label} className="of-filter-tag">
      {label}
      {subcategory === FilterType.FILTER_COST ? ' €' : ''}
      <CL.Icon
        className={`${dsClass.PADDING_LEFT_1} of-filter-tag__filter-close-icon`}
        icon="close"
        size="s"
        type="regular"
        color="black"
        onClick={() => onRemoveFilter()}
      />
    </div>
  );
};
